<template>
  <div class="vx-col w-full lg:w-1/2 mb-base">
    <vx-card title="Vessel Types">
      <template slot="actions">
        <change-vessel-type-dropdown
          @timeDurationChanged="handleTimeDuration"
        />
      </template>
      <vue-apex-charts
        type="bar"
        height="350"
        :options="options"
        :series="series"
      ></vue-apex-charts>
      <template slot="codeContainer"> </template>
    </vx-card>
  </div>
</template>
<script>
import ChangeVesselTypeDropdown from "@/components/ChangeVesselTypeDropdown.vue";

import VueApexCharts from "vue-apexcharts";
var default_options = {
  labels: [],
  dataLabels: {
    enabled: false
  },
  legend: { show: false },
  chart: {
    offsetY: 30,
    type: "bar",
    toolbar: {
      show: false
    }
  },
  stroke: { width: 0 },
  colors: [
    "#2ec1ac",
    "#cd0a0a",
    "#c87941",
    "#3ec1d3",
    "#393b44",
    "#2ec1ac",
    "#cd0a0a",
    "#c87941",
    "#C85A17"
  ],
  fill: {
    type: "gradient",
    gradient: {
      gradientToColors: [
        "#2ec1ac",
        "#cd0a0a",
        "#c87941",
        "#3ec1d3",
        "#393b44",
        "#2ec1ac",
        "#cd0a0a",
        "#c87941",
        "#C85A17"
      ]
    }
  },
  chartOptions: {
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0
      }
    },
    chart: {
      type: "bar",
      sparkline: { enabled: true },
      toolbar: { show: false }
    },
    states: {
      hover: {
        filter: "none"
      }
    },
    colors: [
      "rgba(115,103,240,0.15)",
      "rgba(115,103,240,0.15)",
      "#7367f0",
      "rgba(115,103,240,0.15)",
      "rgba(115,103,240,0.15)",
      "rgba(115,103,240,0.15)"
    ],
    plotOptions: {
      bar: {
        columnWidth: "45%",
        distributed: true,
        endingShape: "rounded" // Deprecated
        // borderRadius: '20px', // Coming Soon
      }
    },
    tooltip: {
      x: { show: false }
    }
  }
};

export default {
  components: {
    VueApexCharts,
    ChangeVesselTypeDropdown
  },

  data() {
    return {
      options: {},
      input: {},
      series: [],
      analyticsData: []
    };
  },
  async mounted() {
    this.getProjectDashboardData();
  },
  methods: {
    async getProjectDashboardData() {
      let response = await this.getHTTPPostResponse(
        "/dashboard/vessels",
        this.input
      );
      if (response) {
        let data_response = response.data["vessel_details"];

        var lables = [];
        var value = [];

        data_response.forEach(element => {
          lables.push(element.key);
          value.push(element.value);
        });
        var series_data = [
          {
            data: value
          }
        ];
        this.series = [];
        this.options = {};

        setTimeout(() => {
          this.series = series_data;
          this.analyticsData = data_response;
          default_options.labels = lables;
          this.options = default_options;
        }, 100);
      }
    },
    handleTimeDuration(type) {
      this.input = {
        subType: type
      };
      this.getProjectDashboardData();
    }
  }
};
</script>
